module.exports = __webpack_public_path__ + "img/制御工学5_8_2.e683378a.png";